import { environment } from '../config/environment'

export class ConfigValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ConfigValidationError'
  }
}

// Validate Authentik configuration
const validateAuthentikConfig = () => {
  if (!environment.authentikClientId) {
    throw new ConfigValidationError('Authentik Client ID is required')
  }
  if (!environment.authentikAuthorizationEndpoint) {
    throw new ConfigValidationError('Authentik Authorization Endpoint is required')
  }
  if (!environment.authentikTokenEndpoint) {
    throw new ConfigValidationError('Authentik Token Endpoint is required')
  }
  if (!environment.authentikUserInfoEndpoint) {
    throw new ConfigValidationError('Authentik User Info Endpoint is required')
  }
  if (!environment.authentikLogoutEndpoint) {
    throw new ConfigValidationError('Authentik Logout Endpoint is required')
  }
}

// Validate all configuration
export const validateConfig = (): void => {
  validateAuthentikConfig()
}
